import { render } from "./CardBusinessList.vue?vue&type=template&id=2362b9f3"
import script from "./CardBusinessList.vue?vue&type=script&lang=js"
export * from "./CardBusinessList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__